export default "/assets/images/mila-air-mini.jpg?566ec12cb9dfda5065e5d0243faf3ddd";